<template>
  <div class="area-tree">
    <div class="bottom">
      <div class="bottonm-head">
        <table class="table table-striped table-bordered border-right-none">
          <thead>
            <tr>
              <th style="width: 30%">省</th>
              <th style="width: 30%">市</th>
            </tr>
          </thead>
          <tbody></tbody>
        </table>
      </div>
      <div class="bottom-body">
        <div v-for="(p, pIndex) in baseAreaAll" :key="p.code" class="item">
          <div class="left">
            <div
              :class="[
                'cb-wrap',
                p.parentCheckStatus == 'part' ? 'cb-part-wrap' : '',
                p.parentCheckStatus == 'all' ? 'cb-all-wrap' : '',
              ]"
            >
              <input
                type="checkbox"
                id="checkbox"
                :checked="p.checked"
                @click="checkProvinceAll(p, pIndex, $event)"
              />
            </div>
            <span @click="selectProvince(p, pIndex)">{{ p.name }}</span>
          </div>
          <div class="right">
            <div v-for="(c, cIndex) in p.children" :key="c.code" class="city">
              <input
                type="checkbox"
                id="checkbox"
                :checked="c.checked"
                @click="areaCheckChange(p, pIndex, c, cIndex, $event)"
              />
              <span>{{ c.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="top" style="margin-top: 20px">
      <div class="buttons-group">
        <Button size="large" @click="back">返回</Button>
        <Button
          size="large"
          type="primary"
          @click="save"
          style="margin-right: 10px"
          >保存</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: ["on-save", "on-cancel"],
  data() {
    return {
      currentP: 0,
      currentC: 0,
      selectArea: {},
    };
  },
  computed: {
    ...mapGetters("base", {
      baseAreaAll: "getBaseAreaAll",
    }),
    ...mapGetters("merchant", {
      spAreaList: "getSpAreaList",
    }),
  },
  watch: {
    baseAreaAll: function (newv) {
      // this.selectProvince(newv[0], 0);
      // this.selectCity(newv[0].children[0], 0);
    },
  },
  created() {
    this.$Spin.show();
    this.$store
      .dispatch("base/getBaseAreaAll")
      .then(() => {})
      .catch((err) => {
        console.log(err);
      })
      .finally(this.$Spin.hide);
  },
  methods: {
    selectCity(c, index) {
      this.$set(this, "currentC", c.code);
    },
    checkProvinceAll(p, pIndex, event) {
      (p.children || []).forEach((c, i) => {
        this.areaCheckChange(p, pIndex, c, i, event);
      });
    },
    areaCheckChange(p, pIndex, c, cIndex, event) {
      const flag = event.target.checked;
      this.$set(c, "checked", flag);
      const pkey = "" + p.code;

      // 选中
      if (flag) {
        // 记录当前area code
        if (!this.selectArea[pkey]) {
          this.$set(this.selectArea, pkey, new Array(p.children.length));
        }

        this.selectArea[pkey].splice(cIndex, 1, c);
      }
      // 取消选中
      else {
        // 清空当前area code
        this.selectArea[pkey].splice(cIndex, 1, false);
      }

      const pStatus = this.judgeAreaNumber(
        this.selectArea[pkey].filter((i) => !!i).length,
        p.children.length
      );
      this.$set(p.children[cIndex], "parentCheckStatus", pStatus);
      this.$set(this.baseAreaAll[pIndex], "parentCheckStatus", pStatus);

      // console.log("已经选中: ", this.selectArea, p);
    },
    judgeAreaNumber(checkLen, allLen) {
      // 全部选中
      if (checkLen >= allLen) {
        return "all";
      }
      // 部分选中
      else if (checkLen > 0) {
        return "part";
      }
      // 没有选中
      else {
        return "none";
      }
    },
    save() {
      // const areaCodeList = [];
      // Object.keys(this.selectArea).forEach((key) => {
      //   this.selectArea[key]
      //     .filter((i) => !!i)
      //     .forEach((a) => areaCodeList.push(a.code));
      // });
      // console.log(areaCodeList);

      this.$emit("on-save", this.selectArea);
    },
    back() {
      this.$emit("on-cancel");
    },
  },
};
</script>

<style scoped>
/* 滚动条宽度 */
::-webkit-scrollbar {
  width: 0;
  background-color: transparent;
}

/* 滚动条颜色 */
::-webkit-scrollbar-thumb {
  background-color: #27314d;
}

.area-tree {
  position: relative;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.top {
  flex: 0 0 auto;
}

.bottom {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  height: 60vh;
  overflow: hidden;
}

.bottonm-head {
  flex: 0 0 auto;
}

.bottom-body {
  flex: 1 1 auto;
  overflow: auto;
}

.bottom-body .item {
  display: flex;
  padding: 10px 0;
  border-top: 1px solid #e7e7e7;
}

.bottom-body .item .left {
  flex: 1;
}

.bottom-body .item .right {
  flex: 4;
  display: flex;
  flex-wrap: wrap;
}

.bottom-body .item .right .city {
  margin: 4px;
}

.cb-wrap {
  display: inline-block;
  width: 16px;
  height: 16px;
  position: relative;
  border-color: #2d8cf0;
  background-color: #ffffff;
  border: 1px solid #dcdee2;
  border-radius: 2px;
  overflow: hidden;
  transition: border-color 0.2s ease-in-out, background-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;
}

.cb-wrap input {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  cursor: pointer;
  opacity: 0;
}

.cb-part-wrap {
  background-color: #2d8cf0;
}

.cb-all-wrap {
  background-color: #2d8cf0;
}

.cb-part-wrap::after {
  content: "";
  width: 10px;
  height: 1px;
  transform: scale(1);
  position: absolute;
  left: 2px;
  top: 6px;
  display: table;
  position: absolute;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transition: all 0.2s ease-in-out;
}
.cb-all-wrap::after {
  content: "";
  display: table;
  width: 4px;
  height: 8px;
  position: absolute;
  top: 2px;
  left: 5px;
  border: 2px solid #fff;
  border-top: 0;
  border-left: 0;
  transform: rotate(45deg) scale(1);
  transition: all 0.2s ease-in-out;
}
</style>


// WEBPACK FOOTER //
// src/components/citySelect.vue